import { PlayerConfig } from '@/interfaces/player-config.interface';

export class AdService {
  public getPrerollUrl(playerConfig: PlayerConfig) {
    const type = playerConfig.live ? 'live' : 'clip';

    const custParams =
      'sourceId=' +
      playerConfig.sourceId +
      '&type=' +
      type +
      '&accountId=' +
      playerConfig.accountId +
      '&targettag=' +
      playerConfig.adTargetTag +
      '&height=' +
      window.innerWidth +
      '&width=' +
      window.innerHeight;

    const uri = playerConfig.advertisement.adserver + '&url=' + playerConfig.parentHost + '&cust_params=' + encodeURIComponent(custParams);
    return uri;
  }

  public getMidrollUrl(playerConfig: PlayerConfig) {
    const type = playerConfig.live ? 'live' : 'clip';

    const custParams =
      'sourceId=' +
      playerConfig.sourceId +
      '&type=' +
      type +
      '&accountId=' +
      playerConfig.accountId +
      '&height=' +
      window.innerWidth +
      '&width=' +
      window.innerHeight;

    // TODO: move to api
    const midrollTest = 'https://pubads.g.doubleclick.net/gampad/live/ads?iu=/1052246/etv_midroll&description_url=[referrer_url]&env=vp&impl=s&correlator=&tfcd=0&npa=1&gdfp_req=1&output=vast&sz=1280x720&min_ad_duration=5000&max_ad_duration=30000&unviewed_position_start=1';

    const uri = midrollTest + '&url=' + playerConfig.parentHost + '&cust_params=' + decodeURIComponent(custParams);
    return uri;
  }
}

export const adService = new AdService();
